'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    install: (0, _logger2.default)().install
};


//////////////////
// WEBPACK FOOTER
// ./~/vuejs-logger/dist/index.js
// module id = pZOg
// module chunks = 5